<section>
  <div class="header-container" style="top:0">
    <h3>Planes y Excedentes</h3>
    <div class="button-wrap">
      <button mat-button (click)="createPlan()">
        <mat-icon>add</mat-icon>Nuevo Plan
      </button>
    </div>
  </div>

  <div class="card">
    <ng2-smart-table
      [settings]="settingsPlans"
      [source]="data_source_3"
      (edit)="editPrice($event, false)"
      (delete)="deletePlan($event.data)"
      (custom)="onCustomAction($event)"
    >
    </ng2-smart-table>
  </div>
</section>

<section>
  <div class="header-container" style="top:0">
    <h3>Excedentes</h3>
   
  </div>

  <div class="card">
    <ng2-smart-table
      [settings]="settingsExcedents"
      [source]="smartTableSource"
      (edit)="editPrice($event, true)"
    >
    </ng2-smart-table>
  </div>
</section>
